import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row } from 'react-bootstrap';
import './VideoFeed.css';
import VideoList from '../../components/VideoList';
import { videoShape } from '../../utils/shapes';
import VideoPlayer from '../../components/VideoPlayer/index';
import 'whatwg-fetch';
import { createStructuredSelector } from 'reselect';
import { selectVideos } from './selectors';
import { setVideos } from './actions';
import { connect } from 'react-redux';

class VideoFeed extends Component {
  constructor(props) {
    super(props);

    const initialVideo = this.getInitialVideo();

    this.state = {
      selectedVideoId: initialVideo ? initialVideo.id.videoId : null,
      loading: true,
      error: false
    };

    this.selectVideo = this.selectVideo.bind(this);
  }

  componentDidMount() {
    this.retrieveVideos();
  }

  retrieveVideos(pageToken, append = false) {
    const { videos, setVideos } = this.props;
    let url = `https://www.googleapis.com/youtube/v3/search?key=${process.env
      .REACT_APP_YOUTUBE_API_KEY}&channelId=${process.env
      .REACT_APP_YOUTUBE_CHANNEL_ID}&part=snippet,id&order=date&maxResult=20`;

    if (pageToken) {
      url += `&pageToken=${pageToken}`;
    }

    fetch(url)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (videos.length + json.items.length < 10) {
          this.retrieveVideos(json.nextPageToken, true);
        }

        if (append) {
          setVideos([...videos, ...json.items]);
        } else {
          setVideos(json.items);
        }
        this.setState({ loading: false });
      });
  }

  componentWillReceiveProps(nextProps) {
    const { videos: nextVideos } = nextProps;

    if (!this.state.selectedVideoId && nextVideos && nextVideos.length > 0) {
      this.selectVideo(nextVideos[0]);
    }
  }

  getInitialVideo() {
    const { videos } = this.props;

    if (videos && videos.length > 0) {
      return videos[0];
    }

    return null;
  }

  selectVideo(video) {
    if (video && video.id) {
      this.setState({ selectedVideoId: video.id.videoId });
    }
  }

  render() {
    const { videos, onInteraction } = this.props;
    const { selectedVideoId, loading, error } = this.state;

    if (loading || !videos || error) {
      return null;
    }

    const selectedVideo = videos.find(
      video => video.id.videoId === selectedVideoId
    );

    return (
      <Grid fluid className="video-feed">
        <Row>
          <div className="col col-left" onMouseEnter={onInteraction}>
            {selectedVideo ? <VideoPlayer video={selectedVideo} /> : ''}
          </div>
          <div className="col col-right" onMouseEnter={onInteraction}>
            {videos && videos.length > 0 && selectedVideo ? (
              <VideoList
                videos={videos}
                onVideoClick={this.selectVideo}
                nowPlayingVideo={selectedVideo}
              />
            ) : (
              ''
            )}
          </div>
        </Row>
      </Grid>
    );
  }
}

VideoFeed.propTypes = {
  videos: PropTypes.arrayOf(videoShape),
  onInteraction: PropTypes.func,
  setVideos: PropTypes.func
};

const mapStateToProps = createStructuredSelector({
  videos: selectVideos
});

const mapDispatchToProps = dispatch => {
  return {
    setVideos: videos => dispatch(setVideos(videos))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoFeed);



// WEBPACK FOOTER //
// ./src/containers/VideoFeed/index.js